// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9c92ff38","952":"752e13e3"}[chunkId] + ".chunk.js";
};